<template>
    <div class="v-flex">
        <div class="mr-2">
            <i class="fa fa-align-justify handle primary--text"></i>
        </div>
        <f-phone-type
            v-model = "type"
            class   = "mr-2"
            @input  = "onChanged"
        />
        <f-country
            v-model = "country"
            @input  = "onChanged"
        />
        <v-text-field
            v-model        = "number"
            class          = "ml-2"
            @input         = "onChanged"
            label          = "Telefonnummer"
            autocomplete   = "off"
            autocorrect    = "off"
            autocapitalize = "off"
            spellcheck     = "false"
        />
        <div class="mr-1" style="padding-top: 18px">
            <a @click="onCopyNumber">
                <v-icon color="primary" size="18" class="toolbar-button">
                    mdi-content-copy
                </v-icon>
            </a>
        </div>
        <div style="padding-top: 19px">
            <a @click="onDelete">
                <v-icon color="error" size="22" class="toolbar-button">
                    mdi-close
                </v-icon>
            </a>
        </div>
    </div>
</template>

<script>

import FCountry from "@/modules/msd/common/components/FCountry";
import { AsYouType } from 'libphonenumber-js'
import Core from "@/modules/core/service/Core";
import FPhoneType from "@/modules/msd/common/components/FPhoneType";

export default {
    name: "FPhoneNumber",

    props: {
        value: {
            required: true,
            type    : Object,
            default : function () {
                return {
                    type   : null,
                    country: null,
                    number : null
                }
            }
        }
    },

    components: {
        FPhoneType,
        FCountry
    },

    data: () => ({
        type   : null,
        country: null,
        number : null,
        code   : null,
        formated: null
    }),

    mounted() {
        this.initialize();
    },

    watch: {
        value () {
            this.initialize();
        }
    },

    methods: {
        initialize () {
            this.type = this.value.type;
            this.code = this.value.iso3166;

            if (this.value) {
                const inputValue = this.value.number;
                if (inputValue &&  inputValue.startsWith ("+") ) {
                    const number = new AsYouType(this.code).input(inputValue);
                    this.country = number.substring (0, 3);
                    this.number  = number.substring (3).trim();
                } else {
                    this.country = null;
                    this.number  = inputValue;
                }
            }
        },

        onChanged () {
            this.$emit("input", {
                id     : this.value.id,
                type   : this.type,
                number : this.country + this.number
            })
        },

        onDelete () {
            this.$emit("delete")
        },

        onCopyNumber () {
            const asYouType = new AsYouType(this.code).input(this.country + this.number);
            navigator.clipboard.writeText(asYouType);
            Core.message.hint(this, asYouType + " wurde ins Clipboard kopiert!")
        }
    }
}
</script>

<style scoped>

.handle {
    float: left;
    padding-top: 8px;
    padding-bottom: 8px;
    font-size: 18px;
    margin-top: 15px;
    cursor: grab;
}


</style>